export default function() {
    return {
        payables: [],
        totalPages: 0,
        currentPage: 0,
        fields: [
            {
                key: 'id',
                label: 'ID Transação'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'type',
                label: 'Tipo'
            },
            {
                key: 'paymentMethod',
                label: 'Forma de pagamento'
            },
            {
                key: 'paymentDate',
                label: 'Liberação'
            },
            {
                key: 'accrualDate',
                label: 'Data do pedido'
            },
            {
                key: 'amount',
                label: 'Valor'
            },
            {
                key: 'installment',
                label: 'Parcela'
            },
        ]
    }
}
